import { FaqClose, FaqOpen } from "./Icon";

import React from "react";
import { Accordion } from "react-bootstrap";

const Faq = () => {
  return (
    <>
      <div id="discord" style={{ transform: "translateY(-70px)" }}></div>
      <div id="faq" style={{ transform: "translateY(-70px)" }}></div>
      <section className="faqs-section">
        <div className="container">
          <div className="row gy-4 flex-wrap-reverse">
            <div className="col-lg-6">
              <div className="faq-left" data-aos="fade-left">
                <div className="inner">
                  <h4 className="title">Get more questions?</h4>
                  <img
                    src={process.env.PUBLIC_URL + "/img/discord.png"}
                    alt=""
                    className="discord"
                  />
                  <h6 className="subtitle">Join the community</h6>
                  <div className="online">
                    <span>2800</span> Members Online
                  </div>

                  <a
                    href="https://discord.gg/carbonmod"
                    target="#"
                    className="btn-base"
                  >
                    <span>Join Discord</span>
                  </a>
                  <img
                    src={process.env.PUBLIC_URL + "/img/discord-bg.png"}
                    alt=""
                    className="discord-bg"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-right">
              <h5 className="section-title mb-4 pt-2">FREQUENT QUESTIONS</h5>
              <div className="faq-wrapper">
                <div className="faqs">
                  <FaqItems />
                </div>
                <img
                  src={process.env.PUBLIC_URL + "/img/panel-left-border.png"}
                  className="d-none d-sm-block"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="overflow-hidden position-relative --line">
        <img src={process.env.PUBLIC_URL + "/img/faq-line-2.png"} alt="" />
      </div>
    </>
  );
};

const FaqItems = () => {
  const [active, setActive] = React.useState(0);
  return (
    <Accordion defaultActiveKey={0}>
      {data?.map(({ title, text }, i) => (
        <div
          key={i}
          className={`accordion--item ${active === i ? "active" : ""}`}
        >
          <Accordion.Item eventKey={i} className={active === i ? "active" : ""}>
            <Accordion.Header
              onClick={() => (active === i ? setActive(null) : setActive(i))}
            >
              <span className="me-2">{title} </span>
              <span className="plus ms-auto">
                <FaqOpen />
              </span>
              <span className="minus ms-auto">
                <FaqClose />
              </span>
            </Accordion.Header>
            <Accordion.Body>
              <div className="d-flex pb-3">
                <div className="line"></div>
              </div>
              <div className="faq-text">
                {text?.map((t, i) => (
                  <p key={i}>{t}</p>
                ))}
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </div>
      ))}
    </Accordion>
  );
};
const data = [
  {
    title: "Will all my oxide plugins work with Carbon?",
    text: [
      "Carbon automatically imports and updates all Oxide hooks to ensure all of your plugins work seemlessly on Carbon. All hooks, including Carbon hooks, will be updated automatically everytime your server restarts. No more having to manually update server files!",
    ],
  },
  {
    title: "How do install carbon?",
    text: [
      "Installing Carbon is very simple, regardless of your operating system. Have a look at our Installing Carbon documentation to get started! Do you use Pterodactyl? One of our amazing community developers has created a Carbon Pterodactyl egg to easily implement into your environment! If you're using LinuxGSM you'll need to add the following to your rustserver.cfg or common.cfg:\npreexecutable='LD_PRELOAD=\"libdoorstop.so\"' export DOORSTOP_ENABLED=1 export DOORSTOP_TARGET_ASSEMBLY=\"${serverfiles}/carbon/managed/Carbon.Preloader.dll\"",
    ],
  },
  {
    title: "How do I install plugins with Carbon?",
    text: [
      "Installing plugins is easy! Simply add the plugin into /carbon/plugins folder or for Harmony, the /carbon/harmony folder. The plugin will be loaded automatically, assuming ScriptWatchers is not disabled in your Carbon config file. If that's the case, simply load the plugin manually with c.load plugin-name. To reload a plugin use c.reload plugin-name, or to unload a plugin, use c.unload plugin-name, replacing plugin-name with the name of the plugin. Be aware that the name is case-sensitive, so be sure to type it correctly.",
    ],
  },
  {
    title: "How can I help support / contribute to the project?",
    text: [
      "This is a community-driven project so we appreciate all the help you can provide. Please star the repository, fork the project, make your own changes, improvements and additions, then create a pull request with a helpful caption, describing your changes and why they're required.",
    ],
  },
  {
    title: "How can I report any issues that I experince?",
    text: [
      "You can submit issues on our Github or in our Discord server. Please include as much information possible to assist us in debugging!",
    ],
  },
];

export default Faq;
